<template>
  <v-container>
    <v-row color="primary">
      <v-col>
        <v-card
          color="primary"
          :class="{ 'degrade-background-sebrae': isSala }"
        >
          <v-row>
            <v-col class="ml-3">
              <v-btn :to="'/cidade/' + municipioId" color="accent">
                <v-icon color="white" large> mdi-arrow-left-bold </v-icon>
                <span style="color: white"
                  >voltar ao {{ isGov ? "projeto" : "município" }}</span
                >
              </v-btn>
            </v-col>
            <selo-logo></selo-logo>
            <template v-if="!isSala">
              <v-col
                align="center"
                justify="center"
                v-if="
                  isFullAdmin ||
                  (groupsConfig.visualizarLogo && config.visualizarLogo)
                "
              >
                <v-img
                  justify="center"
                  :src="'/assets/img/' + logo"
                  width="20%"
                >
                </v-img>
              </v-col>
            </template>
          </v-row>

          <v-row>
            <v-col>
              <v-card-text>
                <h2 class="text-center textoSala" v-if="isSala">
                  CLIQUE SOBRE UM PILAR PARA RESPONDER AS QUESTÕES
                </h2>
                <h2 class="text-center white--text" v-else>
                  CLIQUE SOBRE UM TEMA PARA RESPONDER AS PERGUNTAS
                </h2>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              align="center"
              v-for="tema in temas"
              v-bind:key="tema.temaId"
              :title="temaFilaziado(tema) && 'Diagnostico finalizado'"
            >
              <a
                @click="answerTheme(tema)"
                class="a"
                :style="+temaFilaziado(tema) && '; cursor:default'"
              >
                <div class="lockedTheme" v-if="temaFilaziado(tema)">
                  <v-icon color="accent" size="50"> mdi-lock</v-icon>
                </div>
                <v-progress-circular
                  size="150"
                  :value="
                    (tema.perguntasRespondidas / tema.perguntasTema) * 100
                  "
                  width="15"
                  color="warning"
                  background-color="warning"
                  v-if="!isSala"
                  :style="+temaFilaziado(tema) && 'opacity:0.5; cursor:default'"
                >
                  <img
                    :src="'/assets/img/temas/' + tema.tema.imagem"
                    width="130px"
                    class="tema-image"
                  />
                </v-progress-circular>
                <v-progress-circular
                  size="150"
                  :value="
                    (tema.perguntasRespondidas / tema.perguntasTema) * 100
                  "
                  width="15"
                  color="azulclarosc"
                  background-color="warning"
                  v-if="isSala"
                >
                  <img
                    :src="'/assets/img/temas/' + tema.tema.imagem"
                    width="130px"
                    class="tema-image"
                  />
                </v-progress-circular>
                <!--
                <h4
                  class="text-center white--text"
                >
                  {{ tema.tema.nome }}
                </h4>
              --> </a
              ><br />
              <v-btn
                v-if="
                  (estado === 'SC' ||
                    estado === 'BA' ||
                    estado === 'SP' ||
                    estado === 'MA') &&
                  !isSala
                "
                color="error"
                class="ml-3"
                @click="downloadQuestions(tema.temaId)"
              >
                DOWNLOAD PERGUNTAS
              </v-btn>
            </v-col>
          </v-row>

          <v-row v-if="false">
            <v-col class="text-center">
              <v-btn
                color="error"
                class="ml-3"
                @click="finishDiagnostic()"
                v-if="temasRespondidos"
              >
                FINALIZAR DIAGNÓSTICO
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { attendanceThemeAPI } from "./AttendanceThemeAPI";
import { diagnosticAPI } from "./DiagnosticAPI";
import { mapActions, mapGetters } from "vuex";
import { cityQuestionAPI } from "@/modules/city";
import seloLogo from "../../seloLogo/seloLogo.vue";

export default {
  components: { seloLogo },
  data() {
    return {
      temas: [],
      municipioId: parseInt(this.$route.params.id),
      temasRespondidos: false,
      temasFinalizados: 0,
      logo: this.$store.state.logo,
      estado: this.$store.state.uf,
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadThemes() {
      this.setLoading(true);
      attendanceThemeAPI
        .getByCity(this.municipioId)
        .then((resp) => {
          this.temas = resp.data;

          this.temas = this.temas.filter((tema) =>
            tema.municipio.temas.some(
              (munTema) => munTema.temaId === tema.temaId
            )
          );

          if (!this.isFullAdmin && this.isSala) {
            this.temas = this.temas.filter((item) =>
              JSON.parse(this.config.visualizaEixosIds || "[]").includes(
                item.tema.eixoId
              )
            );
          }

          if (!this.user.grupo.verTodosEixos) {
            this.temas = this.temas.filter((item) =>
              this.user.permissoes.some(
                (per) =>
                  per.eixoId === item.tema.eixoId &&
                  per.municipioId === this.municipioId
              )
            );
          }

          for (let i = 0; i < resp.data.length; i++) {
            if (
              resp.data[i].perguntasTema === resp.data[i].perguntasRespondidas
            ) {
              this.temasFinalizados = this.temasFinalizados + 1;
            }
          }

          if (this.temasFinalizados === resp.data.length) {
            this.temasRespondidos = true;
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("Erro ao listas diagnosticos: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter temas");
        });
    },
    temaFilaziado(tema) {
      let t = false;
      for (let i = 0; i < tema.municipio.temas.length; i++) {
        if (
          tema.municipio.temas[i].temaId === tema.temaId &&
          tema.municipio.temas[i].diagnosticoFinalizado === true
        ) {
          t = true;
        }
      }
      return t;
    },
    answerTheme(tema) {
      if (!this.temaFilaziado(tema))
        for (let i = 0; i < tema.municipio.temas.length; i++) {
          if (
            tema.municipio.temas[i].temaId === tema.temaId &&
            tema.municipio.temas[i].diagnosticoFinalizado === false
          ) {
            this.$router.push(
              "/diagnostico/" + this.municipioId + "/tema/" + tema.temaId
            );
          }
        }
    },
    finishDiagnostic() {
      this.setLoading(true);

      diagnosticAPI
        .finish(this.municipioId)
        .then((resp) => {
          this.$router.push("/cidade/" + this.municipioId + "/geral");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao finalizar diagnóstico");
        });
    },
    downloadQuestions(temaId) {
      this.setLoading(true);

      cityQuestionAPI
        .getPDFPerguntasTema(temaId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Perguntas.pdf";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF de perguntas");
        });
    },
  },
  computed: {
    ...mapGetters(["loading", "isSala", "user", "isFullAdmin", "isGov"]),
  },
  mounted() {
    document.getElementsByClassName("v-main__wrap")[0].style.background =
      'url("/assets/img/bg-diagnostico.jpg") no-repeat ';
    document.getElementsByClassName("v-main__wrap")[0].style.backgroundSize =
      "cover";
    this.loadThemes();
  },
  unmount() {
    document.getElementsByClassName("v-main__wrap")[0].style.background =
      "#fff";
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
<style lang="scss" scoped>
@import "@/variables.scss";
::v-deep .seloHeader {
  flex-direction: column;
  row-gap: 1rem;
}

.textoSala {
  color: $cor-selo-texto;
}

.lockedTheme {
  position: absolute;
  z-index: 2;
  right: 32%;
  top: -66%;
}

.a {
  position: relative;
}
</style>
